<template>
  <div class="lb-bloco " :style="fundo != '' ? 'background-color:' + fundo : ''">
    <h6 class="waves-effect" :style="descricao ? 'margin-top: 0' : ''">
      <strong>
        &nbsp;<i class="fas fa-arrow-left"  @click="Voltar()" :style="'padding-right: 15px;'+colorarrow ? 'color:'+colorarrow : ''">&nbsp;&nbsp;{{titulo}}</i>
      </strong>
    </h6>
    <slot></slot>
    <div>{{descricao}}</div>
  </div>
</template>

<script>
  export default {
    name: "TituloSecao",
    props: ["titulo", "descricao","fundo", "colorarrow"],
    methods:{
      Voltar(){
        this.$router.back();
      }
    }    
  };
</script>

<style scoped>
  .lb-bloco {
    position: relative;
    background-color: #f2f2f2;
    padding: 12px 10px 12px 15px;
    border: 1px solid;
  }
  .lb-bloco > h6 {
    margin: 0;
  }
  .lb-bloco.lb-grupo > h6 {
    font-size: 1.5em;
  }
</style>



// WEBPACK FOOTER //
// src/app/views/template/TituloSecao.vue